// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__BszS+","container":"Modal_container__VSqND"};